import React from 'react';
import { useTranslation } from 'react-i18next';

import { getTimeFormat } from '../../../service/NavPointsUtils';
import { getTimeHHmm } from '../../../service/DateTimeUtils';
import { useStyles } from './useStyles';

export const SummaryCrewTaskInfo = ({ previousTask, declaration, fields, number }) => {
    const classes = useStyles();
    const fieldList = React.useMemo(() => fields.filter(({ id }) => declaration[id]), [fields, declaration]);
    const { t: translate } = useTranslation();

    if (!previousTask) {
        return;
    }

    return (
        <>
            <tr {...(number % 2 !== 1 && { className: classes.highlightRow })}>
                <td className={classes.cell}>
                    {translate('summaryTaskPage.task')} {previousTask.taskNumber}
                </td>
                {fieldList.map(({ id }, index) => (
                    <td key={index} className={classes.cell}>
                        {(id === 'work' && getTimeFormat(previousTask.timeWork)) ||
                            (id === 'workBegin' && getTimeHHmm(previousTask.dateWorkBegin)) ||
                            (id === 'workEnd' && getTimeHHmm(previousTask.dateWorkEnd))}
                    </td>
                ))}
            </tr>
        </>
    );
};
